import Model from '../../ModelBinding/Model';
import OperatorsPaymentCollection from './OperatorsPaymentCollection';
import dayjs from 'dayjs';
import OperatorInvoice from '../OperatorInvoice/OperatorInvoice';

export default class OperatorsPayment extends Model {
  public current_status?:string;
  public method?:string;
  public reference?:string;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public operator_invoice?: OperatorInvoice;
  public api_trace?: string;

  bind() {
    this.current_status = this.getStringAttribute('current_status');
    this.method = this.getStringAttribute('method');
    this.reference = this.getStringAttribute('reference');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.api_trace = this.getStringAttribute('api_trace');
    this.operator_invoice = this.getRelation('address', OperatorInvoice) as OperatorInvoice;
  }

  static getCollection() {
    return OperatorsPaymentCollection;
  }
}
